import React, { useEffect, useState, useMemo } from "react";
import CustomTable from "../../../components/common/CustomTable";
import { MdDone, MdClose, MdRemoveRedEye } from "react-icons/md";
import CustomSidebar from "../../../components/common/CustomSidebar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { userId, userUid } from "../../../utils/storage";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../components/Constant/Notification";
import { ToastContainer } from "react-toastify";
import Header from "../../Header/Header";
import CustomTitle from "../../../GeoLocationCompoents/Custom/CustomTitle";
import allowanceService from "../../Services/allowanceService";
import { MdFilterListAlt } from "react-icons/md";
import CustomSearch from "../../../components/common/CustomSearch";
import ConfirmationModal from "../../../components/shareableContainer/ConfirmationModal";
import { IoMdCloudDownload } from "react-icons/io";
import html2pdf from "html2pdf.js";
import teamService from "../../../components/Services/TeamService";
import CustomChip from "../../../components/common/CustomChip";
import { formatToIndianDate } from "../../../utils/dateFormatter";
import AllowanceRequestFilter from "./AllowanceRequestFilter";
import ImagePopup from "../../../components/common/ImagePopup";
import { IoMdImages } from "react-icons/io";

const AllowanceRequestList = () => {
  const [activeTab, setActiveTab] = useState("PENDING");
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [requestData, setRequestData] = useState([]);
  const [nextCursor, setNextCursor] = useState("");
  const [previousCursor, setPreviousCursor] = useState("");
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [selectedRequestForAction, setSelectedRequestForAction] =
    useState(null);
  const [notes, setNotes] = useState("");
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPermissionType, setSelectedPermissionType] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [teams, setTeams] = useState([]);
  const [cache, setCache] = useState({});
  const [imagePopupVisible, setImagePopupVisible] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [imagePopupTitle, setImagePopupTitle] = useState("");
  const [isEditingAmount, setIsEditingAmount] = useState(false);
  const [editAmount, setEditAmount] = useState("");
  const [editAmountLoading, setEditAmountLoading] = useState(false);

  const tabs = [
    { label: "Pending", value: "PENDING" },
    { label: "Accepted", value: "APPROVED" },
    { label: "Rejected", value: "REJECTED" },
  ];

  const cacheKey = useMemo(() => {
    return `${activeTab}-${startDate?.toISOString() || ""}-${
      endDate?.toISOString() || ""
    }-${limit}-${searchTerm}-${selectedPermissionType?.value || ""}-${
      selectedTeam?.value || ""
    }-${selectedUser?.value || ""}`;
  }, [
    activeTab,
    startDate,
    endDate,
    limit,
    searchTerm,
    selectedPermissionType,
    selectedTeam,
    selectedUser,
  ]);

  const fetchData = async (
    direction = "next",
    cursor = "",
    page = 1,
    removalChip = null,
    overrides = null
  ) => {
    const pageKey = `${cacheKey}-${page}`;
    const cachedData = cache[pageKey];

    if (cachedData && direction !== "refresh") {
      setRequestData(cachedData.data);
      setNextCursor(cachedData.nextCursor);
      setPreviousCursor(cachedData.previousCursor);
      setHasMore(cachedData.hasMore);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      let startDateVal = startDate
        ? startDate.toISOString().split("T")[0]
        : undefined;
      let endDateVal = endDate
        ? endDate.toISOString().split("T")[0]
        : undefined;
      let leaveTypeVal = selectedPermissionType?.value || undefined;
      let teamIdVal = selectedTeam?.value || undefined;
      let employeeIdVal = selectedUser?.value || undefined;
      let searchKeyVal = searchTerm || undefined;

      if (overrides) {
        if ("startDate" in overrides) {
          startDateVal = overrides.startDate
            ? overrides.startDate.toISOString().split("T")[0]
            : undefined;
        }
        if ("endDate" in overrides) {
          endDateVal = overrides.endDate
            ? overrides.endDate.toISOString().split("T")[0]
            : undefined;
        }
        if ("permissionType" in overrides) {
          leaveTypeVal = overrides.permissionType?.value || undefined;
        }
        if ("team" in overrides) {
          teamIdVal = overrides.team?.value || undefined;
        }
        if ("user" in overrides) {
          employeeIdVal = overrides.user?.value || undefined;
        }
        if ("searchTerm" in overrides) {
          searchKeyVal = overrides.searchTerm || undefined;
        }
      }

      if (removalChip === "all" || removalChip === "date") {
        startDateVal = undefined;
        endDateVal = undefined;
      }
      if (removalChip === "all" || removalChip === "permissionType") {
        leaveTypeVal = undefined;
      }
      if (removalChip === "all" || removalChip === "team") {
        teamIdVal = undefined;
      }
      if (removalChip === "all" || removalChip === "user") {
        employeeIdVal = undefined;
      }

      const body = {
        type: activeTab.toUpperCase(),
        next: direction === "next" ? cursor : "",
        limit,
        direction,
        // userId: userId,
        searchKey: searchKeyVal,
        startDate: startDateVal,
        endDate: endDateVal,
        leaveType: leaveTypeVal,
        teamId: teamIdVal,
        employeeId: employeeIdVal,
      };

      const response = await allowanceService.fetchAllowanceRequests(body);

      if (response && response.data) {
        console.log("API Response:", response.data);
        const mappedData = response.data.allowances.map((request) => ({
          id: request.id,
          name: request.userName,
          empId: request.employeeId || "N/A",
          team:
            request.teamNames?.length > 0
              ? request.teamNames.join(", ")
              : "No Team",
          leaveDate: request.date,
          allowanceType: request.type,
          amount: request.amount,
          startTime: request.startTime || "",
          endTime: request.endTime || "",
          appliedDate: request.date,
          modeOfCommunication: request.modeOfCommunication || "",
          handoverTo: request.handoverTo || "N/A",
          compensateType: request.compensateType || "",
          compensateDate: request.compensateDate || "",
          permission: request.status,
          travelFrom: request.travelFrom,
          travelTo: request.travelTo,
          billUrls: request.billUrls || [],
          allowanceDescription: request.allowanceDescription || "",
          notes: request.note || "",
        }));

        console.log(mappedData);

        const newNextCursor = response.data.pagination?.next || "";
        const newPreviousCursor = response.data.pagination?.prev || "";
        const newHasMore = mappedData.length === limit;

        setCache((prevCache) => ({
          ...prevCache,
          [pageKey]: {
            data: mappedData,
            nextCursor: newNextCursor,
            previousCursor: newPreviousCursor,
            hasMore: newHasMore,
          },
        }));

        setRequestData(mappedData);
        setNextCursor(newNextCursor);
        setPreviousCursor(newPreviousCursor);
        setHasMore(newHasMore);
      }
    } catch (error) {
      console.error("Error fetching allowance requests:", error);
      showErrorToast("Failed to fetch allowance requests");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    setCache({});
    fetchData("next", "", 1);
  }, [activeTab, limit]);

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await teamService.getTeamName();
        const data = response.data?.teams || [];
        setTeams(
          data.map((team) => ({ label: team.name, value: team.teamId }))
        );
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };
    fetchTeams();
  }, []);

  const applyFilter = (removalChip = null, overrides = null) => {
    setCurrentPage(1);
    setCache({});
    fetchData("refresh", "", 1, removalChip, overrides);
  };

  const handleRemoveFilter = (filterType) => {
    switch (filterType) {
      case "permissionType":
        setSelectedPermissionType(null);
        break;
      case "team":
        setSelectedTeam(null);
        setSelectedUser(null);
        break;
      case "user":
        setSelectedUser(null);
        break;
      case "date":
        setStartDate(null);
        setEndDate(null);
        break;
      default:
        break;
    }
    applyFilter(filterType);
  };

  const handleClearAllFilters = () => {
    setSelectedPermissionType(null);
    setSelectedTeam(null);
    setSelectedUser(null);
    setStartDate(null);
    setEndDate(null);
    applyFilter("all");
  };

  const handlePageChange = (token, direction) => {
    const newPage =
      direction === "next" ? currentPage + 1 : Math.max(currentPage - 1, 1);
    setCurrentPage(newPage);
    fetchData(
      direction,
      direction === "next" ? nextCursor : previousCursor,
      newPage
    );
  };

  const handlePageSizeChange = (newLimit) => {
    setLimit(newLimit);
  };

  const handleAction = async (allowanceId, action) => {
    // Similar to previous, with optimistic update and cache update
    const updatedData = requestData.map((item) => {
      if (item.id === allowanceId) {
        return { ...item, permission: action.toUpperCase() };
      }
      return item;
    });

    setRequestData(updatedData);

    const pageKey = `${cacheKey}-${currentPage}`;
    const cachedData = cache[pageKey];
    if (cachedData) {
      const updatedCacheData = cachedData.data.map((item) => {
        if (item.id === allowanceId) {
          return { ...item, permission: action.toUpperCase() };
        }
        return item;
      });

      setCache((prevCache) => ({
        ...prevCache,
        [pageKey]: {
          ...cachedData,
          data: updatedCacheData,
        },
      }));
    }

    try {
      const body = {
        allowanceId,
        action: action.toUpperCase(),
        actionBy: userUid,
        ...(action.toUpperCase() === "REJECTED" && { rejectionReason: notes }),
      };

      const response = await allowanceService.updateAllowanceStatus(body);

      if (response?.status === 200) {
        showSuccessToast(
          response.data.message || "Action completed successfully"
        );

        if (activeTab !== action.toUpperCase()) {
          setTimeout(() => {
            setRequestData((prevData) =>
              prevData.filter((item) => item.id !== allowanceId)
            );

            if (cachedData) {
              setCache((prevCache) => ({
                ...prevCache,
                [pageKey]: {
                  ...cachedData,
                  data: cachedData.data.filter(
                    (item) => item.id !== allowanceId
                  ),
                },
              }));
            }
          }, 1000);
        }
      }
    } catch (error) {
      console.error(`Error performing ${action} on allowance request:`, error);
      showErrorToast(
        error.response?.data?.message || `Failed to ${action} request`
      );

      setRequestData((prevData) => {
        return prevData.map((item) => {
          if (item.id === allowanceId) {
            return {
              ...item,
              permission: selectedRequestForAction?.permission || "PENDING",
            };
          }
          return item;
        });
      });

      if (cachedData) {
        setCache((prevCache) => ({
          ...prevCache,
          [pageKey]: cachedData,
        }));
      }
    }
  };

  const showConfirmation = (rowData, action) => {
    setSelectedRequestForAction(rowData);
    setPendingAction(action);
    setShowConfirmModal(true);
    setNotes("");
  };

  const executeConfirmedAction = () => {
    if (selectedRequestForAction && pendingAction) {
      handleAction(selectedRequestForAction.id, pendingAction);
    }
    setShowConfirmModal(false);
    setPendingAction(null);
    setSelectedRequestForAction(null);
    setNotes("");
  };

  const cancelConfirmation = () => {
    setShowConfirmModal(false);
    setPendingAction(null);
    setSelectedRequestForAction(null);
    setNotes("");
  };

  const handleAccept = (rowData) => showConfirmation(rowData, "APPROVED");
  const handleReject = (rowData) => showConfirmation(rowData, "REJECTED");
  const handleToggleToReject = (rowData) =>
    showConfirmation(rowData, "REJECTED");
  const handleToggleToAccept = (rowData) =>
    showConfirmation(rowData, "APPROVED");

  const handleViewDetails = (rowData) => {
    const updatedRequest = requestData.find((item) => item.id === rowData.id);
    setSelectedRequest(updatedRequest);
    setEditAmount(rowData.amount?.toString() || "");
    setSidebarVisible(true);
  };

  const handleStartEditAmount = () => {
    setIsEditingAmount(true);
    setEditAmount(selectedRequest?.amount?.toString() || "");
  };

  const handleCancelEditAmount = () => {
    setIsEditingAmount(false);
    setEditAmount("");
  };

  const handleSaveEditAmount = async () => {
    if (!editAmount || parseFloat(editAmount) <= 0) {
      showErrorToast("Please enter a valid amount greater than 0");
      return;
    }

    setEditAmountLoading(true);
    try {
      const body = {
        allowanceId: selectedRequest.id,
        amount: parseFloat(editAmount),
        modifiedById: userUid,
      };

      const response = await allowanceService.editAllowanceAmount(body);

      if (response.status === 200) {
        showSuccessToast(
          response.data.message || "Amount updated successfully"
        );
        const updatedRequest = {
          ...selectedRequest,
          amount: parseFloat(editAmount),
        };
        setSelectedRequest(updatedRequest);

        const updatedData = requestData.map((item) =>
          item.id === selectedRequest.id
            ? { ...item, amount: parseFloat(editAmount) }
            : item
        );
        setRequestData(updatedData);

        const pageKey = `${cacheKey}-${currentPage}`;
        const cachedData = cache[pageKey];
        if (cachedData) {
          const updatedCacheData = cachedData.data.map((item) =>
            item.id === selectedRequest.id
              ? { ...item, amount: parseFloat(editAmount) }
              : item
          );

          setCache((prevCache) => ({
            ...prevCache,
            [pageKey]: { ...cachedData, data: updatedCacheData },
          }));
        }

        setIsEditingAmount(false);
        setEditAmount("");
      }
    } catch (error) {
      console.error("Error updating amount:", error);
      showErrorToast(
        error.response?.data?.message || "Failed to update amount"
      );
    } finally {
      setEditAmountLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    applyFilter(null, { searchTerm: searchTerm });
  };

  const handleViewImages = (billUrls, userName) => {
    const validUrls = billUrls.filter(
      (url) => url && url.trim() !== "" && url !== "null"
    );
    if (validUrls.length > 0) {
      setSelectedImages(validUrls);
      setImagePopupTitle(`${userName} - Bill Images`);
      setImagePopupVisible(true);
    }
  };

  const columns = [
    {
      key: "name",
      title: "User Name",
      render: (value) => <div className="text-center font-medium">{value}</div>,
    },
    {
      key: "allowanceType",
      title: "Allowance Type",
      render: (value) => (
        <div className="text-center">
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${
              value === "TRAVEL"
                ? "bg-blue-100 text-blue-800"
                : "bg-gray-100 text-gray-800"
            }`}
          >
            {value}
          </span>
        </div>
      ),
    },
    {
      key: "amount",
      title: "Allowance Amount",
      render: (value) => (
        <div className="text-center font-medium">₹{value}</div>
      ),
    },
    {
      key: "billUrls",
      title: "Bill",
      render: (value, row) => {
        const validUrls = value.filter(
          (url) => url && url.trim() !== "" && url !== "null"
        );
        return (
          <div className="text-center flex justify-center">
            {validUrls.length > 0 ? (
              <button
                onClick={() => handleViewImages(value, row.name)}
                className="bg-blue-100 text-blue-500 flex items-center  gap-2 px-3 py-1 rounded text-sm transition-colors"
              >
                <IoMdImages className="text-blue-500" /> View (
                {validUrls.length})
              </button>
            ) : (
              <span className="text-gray-400 text-sm">No files</span>
            )}
          </div>
        );
      },
    },
    {
      key: "permission",
      title: "Permission",
      render: (value, row) => {
        if (value === "PENDING") {
          return (
            <div className="flex gap-2 justify-center items-center">
              <button
                onClick={() => handleAccept(row)}
                className="flex items-center gap-1 text-green-500 px-3 py-1 rounded-full text-sm transition-colors"
              >
                <div className="p-[3px] rounded-full text-white bg-green-500">
                  <MdDone className="text-sm" />
                </div>
                Accept
              </button>
              <button
                onClick={() => handleReject(row)}
                className="flex items-center gap-1 text-red-500 px-3 py-1 rounded-full text-sm transition-colors"
              >
                <div className="p-[3px] rounded-full text-white bg-red-500">
                  <MdClose className="text-sm" />
                </div>
                Reject
              </button>
            </div>
          );
        } else {
          const isAccepted = value === "APPROVED";
          return (
            <div className="flex justify-center items-center">
              <div className="flex items-center gap-3">
                <span
                  className={`text-sm font-medium ${
                    !isAccepted ? "text-red-600" : "text-gray-400"
                  }`}
                >
                  Reject
                </span>
                <label className="inline-flex cursor-pointer">
                  <input
                    type="checkbox"
                    checked={isAccepted}
                    onChange={() =>
                      isAccepted
                        ? handleToggleToReject(row)
                        : handleToggleToAccept(row)
                    }
                    className="sr-only peer"
                  />
                  <div
                    className={`relative w-12 h-6 rounded-full transition-colors ${
                      isAccepted ? "bg-emerald-600" : "bg-red-500"
                    } after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${
                      isAccepted ? "after:translate-x-6" : ""
                    }`}
                  />
                </label>
                <span
                  className={`text-sm font-medium ${
                    isAccepted ? "text-emerald-600" : "text-gray-400"
                  }`}
                >
                  Accept
                </span>
              </div>
            </div>
          );
        }
      },
    },
    {
      key: "Action",
      title: "Action",
      render: (value, row) => (
        <div className="flex gap-4 justify-center">
          <button
            onClick={() => handleViewDetails(row)}
            className="text-blue-500 hover:text-blue-700 transition-colors"
            title="View Details"
          >
            <MdRemoveRedEye className="text-xl" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Header />
      <ToastContainer />
      <div className="pt-28 px-6 pb-10">
        <div className="flex justify-between items-center mb-6">
          <CustomTitle
            title={"Allowance Requests"}
            textColor={"primary"}
            isIcon={true}
          />
          <div className="flex items-center gap-4">
            <CustomSearch
              placeholder="Search by Name"
              handleSearchChange={handleSearchChange}
              searchTerm={searchTerm}
              handleSearchSubmit={handleSearchSubmit}
            />
            <button
              onClick={() => setIsFilterOpen(true)}
              className="bg-white justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px] flex items-center gap-3 text-customGreen py-2 px-4 hover:bg-appGreenHover transition duration-300"
            >
              Filters
              <MdFilterListAlt />
            </button>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mb-4">
          {selectedPermissionType && (
            <CustomChip
              value={`Type: ${selectedPermissionType.label}`}
              onRemove={() => handleRemoveFilter("permissionType")}
            />
          )}
          {selectedTeam && (
            <CustomChip
              value={`Team: ${selectedTeam.label}`}
              onRemove={() => handleRemoveFilter("team")}
            />
          )}
          {selectedUser && (
            <CustomChip
              value={`User: ${selectedUser.label}`}
              onRemove={() => handleRemoveFilter("user")}
            />
          )}
          {startDate && endDate && (
            <CustomChip
              value={`Date: ${formatToIndianDate(
                startDate
              )} - ${formatToIndianDate(endDate)}`}
              onRemove={() => handleRemoveFilter("date")}
            />
          )}
        </div>

        <div className="mb-6">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              {tabs.map((tab) => (
                <button
                  key={tab.label}
                  onClick={() => setActiveTab(tab.value)}
                  className={`py-2 px-1 border-b-2 font-medium text-base whitespace-nowrap ${
                    activeTab === tab.value
                      ? "border-customGreen text-customGreen"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>
        </div>

        <CustomTable
          isPagination={true}
          data={requestData}
          columns={columns}
          loading={loading}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          currentPage={currentPage}
          pageSize={limit}
          hasMore={hasMore}
        />

        <CustomSidebar
          title="Allowance Request Details"
          visible={sidebarVisible}
          onHide={() => setSidebarVisible(false)}
          style={{ width: "400px" }}
          children={
            <div className="space-y-6">
              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4" htmlFor="">
                  Employee Name
                </label>
                <div className="col-span-8">
                  <input
                    type="text"
                    value={selectedRequest?.name || ""}
                    readOnly
                    className="border col-span-8 rounded text-sm w-full input-focus px-3 py-2"
                  />
                </div>
              </div>

              {/* Travel From */}

              {/* Travel To */}
              {selectedRequest?.allowanceType === "TRAVEL" && (
                <>
                  <div className="grid grid-cols-12 items-center">
                    <label className="col-span-4">Travel From</label>
                    <div className="col-span-8">
                      <input
                        type="text"
                        value={selectedRequest?.travelFrom || ""}
                        readOnly
                        className="border rounded text-sm w-full px-3 py-2"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-12 items-center">
                    <label className="col-span-4">Travel To</label>
                    <div className="col-span-8">
                      <input
                        type="text"
                        value={selectedRequest?.travelTo || ""}
                        readOnly
                        className="border rounded text-sm w-full px-3 py-2"
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4">Travel Type</label>
                <div className="col-span-8">
                  <input
                    type="text"
                    value={selectedRequest?.allowanceType || ""}
                    readOnly
                    className="border rounded text-sm w-full px-3 py-2"
                  />
                </div>
              </div>
              <div className="grid grid-cols-12 items-center">
                <label className="col-span-4" htmlFor="">
                  Date
                </label>
                <div className="col-span-8">
                  <input
                    type="text"
                    value={selectedRequest?.leaveDate || ""}
                    readOnly
                    className="border col-span-8 rounded text-sm w-full input-focus px-3 py-2"
                  />
                </div>
              </div>
              <div className="grid grid-cols-12">
                <label className="col-span-4" htmlFor="">
                  Allowance Amount
                </label>
                <div className="col-span-8">
                  {isEditingAmount ? (
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        value={editAmount}
                        onChange={(e) => setEditAmount(e.target.value)}
                        className="border rounded text-sm w-full input-focus px-3 py-2"
                      />
                      <button
                        onClick={handleSaveEditAmount}
                        className={`bg-customGreen text-white px-3 py-1 rounded ${
                          editAmountLoading
                            ? "opacity-50 cursor-not-allowed"
                            : ""
                        }`}
                        disabled={editAmountLoading}
                      >
                        {editAmountLoading ? "Saving..." : "Save"}
                      </button>
                      <button
                        onClick={handleCancelEditAmount}
                        className="bg-gray-200 text-gray-800 px-3 py-1 rounded"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <input
                        type="text"
                        value={`₹${selectedRequest?.amount || ""}`}
                        readOnly
                        className="border rounded text-sm w-full input-focus px-3 py-2"
                      />
                      {selectedRequest?.permission === "PENDING" && (
                        <button
                          onClick={handleStartEditAmount}
                          className="bg-blue-500 text-white px-3 py-1 rounded"
                        >
                          Edit
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
              {selectedRequest?.allowanceType === "OTHERS" && (
                <div className="grid grid-cols-12 items-center">
                  <label className="col-span-4">Description</label>
                  <div className="col-span-8">
                    <textarea
                      rows={4}
                      type="text"
                      value={selectedRequest?.allowanceDescription || ""}
                      readOnly
                      className="border rounded text-sm w-full px-3 py-2"
                    />
                  </div>
                </div>
              )}
              <div className="grid grid-cols-12">
                <label className="col-span-4" htmlFor="">
                  Notes
                </label>
                <div className="col-span-8">
                  <textarea
                    rows={5}
                    value={selectedRequest?.notes || ""}
                    readOnly
                    className="border col-span-8 rounded text-sm w-full input-focus px-3 py-2"
                  />
                </div>
              </div>
              <div className="grid grid-cols-12">
                <label className="col-span-4" htmlFor="">
                  Permission Status
                </label>
                <div className="col-span-8">
                  {selectedRequest?.permission === "APPROVED" ? (
                    <span className="text-green-500 font-semibold">
                      Approved
                    </span>
                  ) : selectedRequest?.permission === "REJECTED" ? (
                    <span className="text-red-500 font-semibold">Rejected</span>
                  ) : (
                    <span className="text-yellow-500 font-semibold">
                      Pending
                    </span>
                  )}
                </div>
              </div>
            </div>
          }
        />
        <AllowanceRequestFilter
          visible={isFilterOpen}
          onHide={() => setIsFilterOpen(false)}
          teams={teams}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          selectedPermissionType={selectedPermissionType}
          setSelectedPermissionType={setSelectedPermissionType}
          selectedTeam={selectedTeam}
          setSelectedTeam={setSelectedTeam}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          handleApplyFilter={applyFilter}
          clearFilters={handleClearAllFilters}
        />
        <ConfirmationModal
          showModal={showConfirmModal}
          title={"Confirm Action"}
          content={
            pendingAction === "REJECTED" ? (
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Please provide a reason for rejection"
                className="w-full border input-focus border-gray-300 rounded-md shadow-sm p-2"
                rows={3}
              />
            ) : null
          }
          message={"Are you sure you want to proceed with this action?"}
          onConfirm={executeConfirmedAction}
          onCancel={cancelConfirmation}
        />
        <ImagePopup
          visible={imagePopupVisible}
          onHide={() => setImagePopupVisible(false)}
          images={selectedImages}
          title={imagePopupTitle}
        />
      </div>
    </div>
  );
};

export default AllowanceRequestList;
